import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

class ScheduleGradePlanningAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      start: this.props.add_planning.start,
      finish: this.props.add_planning.finish,
      staff_id: this.props.add_planning.staff_id,
      days: this.props.add_planning.days,
      extra_salary: this.props.add_planning.extra_salary,
      staff_vacation_id: this.props.add_planning.staff_vacation_id,
      planning_id: this.props.add_planning.planning_id,
      staff_vacations_select: this.props.add_planning.staff_vacations_select,
    };

    this.add = this.add.bind(this);
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // Adiciono uma aeronave na escala
  add(event) {
    event.preventDefault();
    var datasave = {
      planning_id: this.state.planning_id,
      staff_id: this.state.staff_id,
      staff_vacation_id: this.state.staff_vacation_id,
      days: this.state.days,
      extra_salary: this.state.extra_salary,
      start: this.state.start,
      finish: this.state.finish,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    self.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cadastrar/colaborador/ferias', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });   
  }    

  render() {
    var self = this;
    return (
    <form onSubmit={this.add}>
      <RequestApi ref={'request_api'} />
      <div className="row">
        <div className="col-md-4 form-group">
            <label>Início das férias:</label>
          <InputMask value={this.state.start}  maskChar={null} name="start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'start')} placeholder="" disabled />
        </div>
        <div className="col-md-4 form-group">
            <label>Fim das férias:</label>
          <InputMask value={this.state.finish}  maskChar={null} name="finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'finish')} placeholder="" disabled />
        </div>
        <div className="col-md-4 form-group">
            <label>Vencimento de férias:</label>
            <Select
                className=""
                name="staff_vacation_id"
                value={this.state.staff_vacation_id}
                searchable={true}
                placeholder={'Selecionar vencimento'}
                onChange={this.handleSelectChange.bind(this, 'staff_vacation_id')}
                options={this.state.staff_vacations_select}
                required
            />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 form-group">
            <label>Dias de férias (dd):</label>
            <input type="number" className="form-control" name="days" value={this.state.days} onChange={this.handleChange.bind(this, 'days')} required />
        </div>
        <div className="col-md-6 form-group">
            <label>Adiantamento 13º</label>
            <br/>
            <Toggle
                checked={this.state.extra_salary}
                aria-label='No label tag'
                name="extra_salary"
                onChange={this.handleToggleChange.bind(this, 'extra_salary')} />
        </div>
      </div>

      <hr />
      <button type="submit" className="btn btn-success btn-block"><i className="fa fa-fw fa-save"></i>Adicionar férias</button>
      <hr />
    </form>
    );
  }
}

export default ScheduleGradePlanningAdd;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradePlanningAdd.js